import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Col, Card, CardBody, Button, ModalHeader, ModalBody, ModalFooter, Row, FormGroup, Form, Input } from 'reactstrap'
import withAuth from '../../../components/Services/WithAuth';
import Table from '../../../components/UI/Table/Table'
import TransactionReport from './TransactionReportModal/index';
import DatePicker from 'react-datepicker';
import OneClickCorparateOnBoarding from '../OneClickOnboard';
import { FROM_DATE, TO_DATE } from './constant';
import { downloadCorporateCSVRequest } from './action';
import {
  listCorporate,
  transactionDataFileUpload,
  transactionDataCheck,
  transactionDataList,
  deleteTransactionData,
  downloadTransactionTemplate,
  downloadTransactionFile,
  downloadExcelFile,
  downloadNonFinancialExcelFile,
  downloadObjectListExcelFile,
  downloadScoreBreakupExcelFile,
  downloadCLMBreakupExcelFile
} from './action';
import { Link } from "react-router-dom";
import Modal from '../../../components/UI/Modal/Modal';
import { checkTransactionData, getTransactionDataCheckBody, getTransactionDataRequest, dataStatusCheck } from './helper';
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import { Preloading } from '../../../components/UI/Preloader/action';
import { PARTIAL_FAILURE, ENTER } from './constant';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
import moment from 'moment';

let that;
const checkFlagFinancial="Fincancial";
const checkFlagNonFinancial="nonFinancial";
const checkFlagObjectList="objectList";
const TABLE_COLUMN = [
  {
    Header: "Name",
    id: "corporateName",
    accessor: p => <p className="text-truncate" style={{ maxWidth: '150px' }}>{p.corporateName}</p>
  },
  {
    Header: "GST No",
    id: "ETA",
    // maxWidth: 100,
    accessor: p => <div>{p.gstNo}</div>,

  },
  {
    Header: "PAN No",
    id: "status",
    accessor: p => <div>{p.panNo}</div>,
    className: 'center'
  },
  {
    Header: "Action",
    id: "Edit",
    maxWidth: 80,
    accessor: p => <Link tag="button" id={p.id} to={`../corporate/onboarding/edit/${p.id}/companysetup`}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></Link>,
  },
  {
    Header: "Financial Key Extraction",
    id: "KeyExtract",
    maxWidth: 120,
    accessor: p =><button className="icon-download border border-primary radius-4 p-2  font-size-16 btn-outline-primary btn " color="primary" title="Download Financial Key Extract" onClick={() =>that.handleExcelDownload(p,checkFlagFinancial)}>
  </button>,
  className: 'center'
  },
  {
    Header: "Non financial Key Extraction",
    id: "KeyExtractNonFinancial",
    maxWidth: 130,
    accessor: p =><button className="icon-download border border-primary radius-4 p-2  font-size-16 btn-outline-primary btn " color="primary" title="Download Non Financial Key Extract" onClick={() =>that.handleExcelDownload(p,checkFlagNonFinancial)}>
  </button>,
  className: 'center'
  },{
    Header: "ObjectList Key Extraction",
    id: "KeyExtractObjectList",
    maxWidth: 130,
    accessor: p =><button className="icon-download border border-primary radius-4 p-2  font-size-16 btn-outline-primary btn " color="primary" title="Download ObjectList Key Extract" onClick={() =>that.handleExcelDownload(p,checkFlagObjectList)}>
  </button>,
  className: 'center'
  },
  {
    Header: "Score Break-up Extraction",
    id: "KeyScoreExtract",
    maxWidth: 130,
    accessor: p =><button className="icon-download border border-primary radius-4 p-2  font-size-16 btn-outline-primary btn " color="primary" title="Download Score Break-Up Extract" onClick={() =>that.toggleScoreExtractDownloadModal(p)}>
  </button>,
  className: 'center'
  },
  {
    Header: "CLM Break-up",
    id: "CLMExtract",
    maxWidth: 130,
    accessor: p =><button className="icon-download border border-primary radius-4 p-2  font-size-16 btn-outline-primary btn " color="primary" title="Download Score Break-Up Extract" onClick={() =>that.toggleCLMExtractDownloadModal(p)}>
  </button>,
  className: 'center'
  }

]
class ListCorporates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkFlag:"",
      extractionToDate: null,
      extractionFromDate: null,
      keyExtractDownload:false,
      dropdownOpen: false,
      selected: "Name",
      inputText: "",
      loading: true,
      corporateList: [],
      showModal: false,
      body: null,
      confirmModal: false,
      confirmModalBody: null,
      toDate: null,
      fromDate: null,
      selectedCorporate: {},
      selectedCorporateForDownload:{},
      formData: {},
      transactionUploadFailure: [],
      transactionData: [],
      uploadFlag: false,
      scoreExtractDownload: false,
      clmExtractDownload: false,
      showOnboardModal: false
    };
    this.refreshInterval = null;
    that = this;
  }
fetchCorporateList = (pageNo, pageSize) => {
  const requestBody = {
    corporateName: this.state.inputText || ""
  };

  const pageDescription = {
    pageNo,
    pageSize
  };
  this.setState({pageNo, pageSize, loading: true});

  this.props.listCorporate({ requestBody, pageDescription });
};
componentDidMount() {
  setPageView('/Admin/corporate/list', document.location.href);
  this.fetchCorporateList(0, 10);
}

  componentDidUpdate(prevProps) {
    const { corporateList, corporateListFailure, checkTransactionData, checkTransactionDataFailure, transactionDataUpload,
      transactionDataUploadFailure, transactionDataListSuccess, deleteSuccess, deleteFailure,
      downloadTemplate, downloadTemplateFailure, downloadFile, downloadFileFailure,
      downloadExcelFileSuccess,downloadExcelFileFailure,downloadNonFinancialExcelFileFailure,
      downloadNonFinancialExcelFileSuccess,downloadObjectListExcelFileFailure,downloadObjectListExcelFileSuccess, downloadScoreBreakupExcelFileSuccess,
      downloadScoreBreakupExcelFileFailure,downloadCLMBreakupExcelFileSuccess,downloadCLMBreakupExcelFileFailure} = this.props
    if (corporateList !== prevProps.corporateList) {
      this.setState({
        corporateList: this.props.corporateList,
        loading: false
      })
    }
    if (corporateListFailure !== prevProps.corporateListFailure) {
      if (corporateListFailure === false) {
        this.props.history.push('/error-page');
      }
    }
    if (checkTransactionData !== prevProps.checkTransactionData) {
      this.uploadData()
    }
    if (checkTransactionDataFailure !== prevProps.checkTransactionDataFailure) {
      this.props.preloading(false);
      this.setState((prevState) => ({
        confirmModal: !prevState.confirmModal,
        confirmModalBody: <div>
          <ModalHeader>Confirm</ModalHeader>
          <ModalBody>
            <p>Are you sure you want to override the data</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleconfirmModal}>Close</Button>
            <Button color="primary" onClick={this.uploadData}>Proceed</Button>
          </ModalFooter>
        </div>
      }))
    }
    if (downloadTemplate !== prevProps.downloadTemplate) {
      this.props.preloading(false);
      var blob = new Blob([downloadTemplate], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      fileSaver.saveAs(blob, `${this.state.selectedCorporate.corporateName} Transaction Template.xlsx`);
    }
    if (downloadTemplateFailure !== prevProps.downloadTemplateFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{downloadTemplateFailure.data.message}
        </div>
      );
    }
    if (downloadFile !== prevProps.downloadFile) {
      this.props.preloading(false);
      window.open(downloadFile)
    }
    if (downloadFileFailure !== prevProps.downloadFileFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{downloadFileFailure.data.message}
        </div>
      );
    }
    if (deleteSuccess !== prevProps.deleteSuccess) {
      this.props.preloading(false);
      toast.success(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{deleteSuccess.message}
        </div>
      );
      let tempTransactionDataRequest = getTransactionDataRequest(this.state.selectedCorporate);
      this.props.transactionDataList(tempTransactionDataRequest)
    }
    if (deleteFailure !== prevProps.deleteFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{(deleteFailure.response && deleteFailure.response.data) ? deleteFailure.response.data.message : "Something went wrong! Please try again."}
        </div>
      );
    }
    if (transactionDataUpload !== prevProps.transactionDataUpload) {
      this.props.preloading(false);
      goolgeAnalyticsEvents('Admin', 'Upload CorporateTransactional Data', 'Upload', this.state.selectedCorporate.corporateName);
      toast.success(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Transaction Data Uploaded Successfully.
        </div>
      );
      this.setState((prevState) => ({
        confirmModal: false,
        transactionUploadFailure: [],
        transactionData: transactionDataUpload.transactionData,
        uploadFlag: true,
      }), () => {
        const statusFlag = dataStatusCheck(transactionDataUpload.transactionData);
        if (statusFlag) {
          this.handleUploadNew(this.state.selectedCorporate, false)
        } else {
          this.handleUploadNew(this.state.selectedCorporate, true);
        }
      })
    }
    if (transactionDataUploadFailure !== prevProps.transactionDataUploadFailure) {
      this.props.preloading(false);
      this.setState({
        confirmModal: false,
        transactionUploadFailure: (transactionDataUploadFailure.response && transactionDataUploadFailure.response.data) ? transactionDataUploadFailure.response.data.message : "Something went wrong! Please try again."
      }, () => {
        this.handleUploadNew(this.state.selectedCorporate, false)
      })
    }
    if (transactionDataListSuccess !== prevProps.transactionDataListSuccess) {
      // this.props.preloading(false);
      this.setState({
        transactionData: transactionDataListSuccess.transactionData,
        uploadFlag: false
      }, () => {
        const statusFlag = dataStatusCheck(transactionDataListSuccess.transactionData);
        if (statusFlag) {
          this.handleUploadNew(this.state.selectedCorporate, false)
        } else {
          this.refreshInterval = setTimeout(() => {
            this.handleUploadNew(this.state.selectedCorporate, true)
          }, 10000)
        }
      })
    }
    if(downloadExcelFileSuccess!==prevProps.downloadExcelFileSuccess){
        this.props.preloading(false);
        const data = this.props.downloadExcelFileSuccess.data;
        let blob = new Blob([data],  {type: "application/octet-stream"  });
        fileSaver.saveAs(blob, `${this.state.selectedCorporateForDownload.corporateName}_Corporate_Key_Extraction_Financial_${moment().format("DD_MMM_YYYY")}.xlsx`)
    }
    if(downloadExcelFileFailure!==prevProps.downloadExcelFileFailure){
      this.props.preloading(false);
      <div>
      <i className="fa fa-exclamation-triangle"></i>Please Try again !!
     </div>
    }
    if(downloadNonFinancialExcelFileSuccess!==prevProps.downloadNonFinancialExcelFileSuccess){
      this.props.preloading(false);
      const data = this.props.downloadNonFinancialExcelFileSuccess.data;
      let blob = new Blob([data],  {type: "application/octet-stream"  });
      fileSaver.saveAs(blob, `${this.state.selectedCorporateForDownload.corporateName}_Corporate_Key_Extraction_Non_Financial_${moment().format("DD_MMM_YYYY")}.xlsx`)
  }
  if(downloadNonFinancialExcelFileFailure!==prevProps.downloadNonFinancialExcelFileFailure){
    this.props.preloading(false);
    <div>
    <i className="fa fa-exclamation-triangle"></i>Please Try again !!
   </div>
  }

  if(downloadObjectListExcelFileSuccess!==prevProps.downloadObjectListExcelFileSuccess){
    this.props.preloading(false);
    const data = this.props.downloadObjectListExcelFileSuccess.data;
    let blob = new Blob([data],  {type: "application/octet-stream"  });
    fileSaver.saveAs(blob, `${this.state.selectedCorporateForDownload.corporateName}_Corporate_Key_Extraction_Object_List_${moment().format("DD_MMM_YYYY")}.xlsx`)
}
if(downloadObjectListExcelFileFailure!==prevProps.downloadObjectListExcelFileFailure){
  this.props.preloading(false);
  <div>
  <i className="fa fa-exclamation-triangle"></i>Please Try again !!
 </div>
}
   if(downloadScoreBreakupExcelFileSuccess!==prevProps.downloadScoreBreakupExcelFileSuccess){
      this.props.preloading(false);
      const data = this.props.downloadScoreBreakupExcelFileSuccess.data;
      let blob = new Blob([data],  {type: "application/octet-stream"  });
      fileSaver.saveAs(blob, `${this.state.selectedCorporateForDownload.corporateName}_Score_Breakup_Extraction_${moment().format("DD_MMM_YYYY")}.xlsx`)
   }
   if(downloadScoreBreakupExcelFileFailure!==prevProps.downloadScoreBreakupExcelFileFailure){
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Error in getting scorecard break-up extract
        </div>
      );
  }

  if(downloadCLMBreakupExcelFileSuccess!==prevProps.downloadCLMBreakupExcelFileSuccess){
    this.props.preloading(false);
    const data = this.props.downloadCLMBreakupExcelFileSuccess.data;
    let blob = new Blob([data],  {type: "application/octet-stream"  });
    fileSaver.saveAs(blob, `${this.state.selectedCorporateForDownload.corporateName}_CLM_Breakup_Extraction_${moment().format("DD_MMM_YYYY")}.xlsx`)
 }
 if(downloadCLMBreakupExcelFileFailure!==prevProps.downloadCLMBreakupExcelFileFailure){
    this.props.preloading(false);
    toast.error(
      <div>
        <i className="fa fa-exclamation-triangle"></i>&nbsp;Error in getting Credit Limit break-up extract
      </div>
    );
}

  }


  toggleModal = () => {
    if (this.refreshInterval) {
      clearTimeout(this.refreshInterval);
    }

    this.setState((prevState) => ({
      showModal: !prevState.showModal
    }))
  }
  toggleconfirmModal = () => {
    this.setState((prevState) => ({
      confirmModal: !prevState.confirmModal
    }))
  }
  handleUploadNew = (data, flag) => {
    if (flag) {
      // this.props.preloading(true);
      let tempTransactionDataRequest = getTransactionDataRequest(data);
      this.props.transactionDataList(tempTransactionDataRequest)
      this.setState((prevState) => ({
        transactionUploadFailure: [],
        uploadFlag: !prevState.uploadFlag
      }))
    }
    this.setState((prevState) => ({
      selectedCorporate: data,
      showModal: true,
      body: <TransactionReport
        downloadTemplateCallback={this.handleDownloadTemplate}
        handleDownloadCallback={this.handleDownload}
        deleteTransactionCallback={this.handleDelete}
        uploadFlag={this.state.uploadFlag}
        corporateData={data}
        transactionDataErrors={this.state.transactionUploadFailure}
        transactionData={this.state.transactionData}
        transactionReportCallback={this.handleTransactioReoprtUpload}
        toggleModal={this.toggleModal} />
    }))

  }
  handleDownloadTemplate = (data) => {
    this.props.preloading(true);
    this.props.downloadTransactionTemplate(data.id)
  }
  handleDownload = (data) => {
    this.props.preloading(true);
    if (data.status === PARTIAL_FAILURE) {
      this.props.downloadTransactionFile(data.failureFileKey)
    } else {
      this.props.downloadTransactionFile(data.s3FileKey)
    }
  }
  handleDelete = (data) => {
    this.props.preloading(true);
    this.props.deleteTransactionData(data.id);
  }
  uploadData = () => {
    this.toggleconfirmModal();
    this.props.preloading(true);
    this.props.transactionDataFileUpload(this.state.formData);
  }
  handleTransactioReoprtUpload = (data) => {
    const validateTransactionData = checkTransactionData(data);
    if (validateTransactionData) {
      this.setState({
        formData: data
      })
      let transactionDataCheckRequestBody = getTransactionDataCheckBody(data);
      this.props.transactionDataCheck(transactionDataCheckRequestBody);
      this.props.preloading(true)
    } else {
      toast.warn(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Required Fields are empty.
        </div>
      );
    }
  }
  handleExcelDownload = (data,checkFlag) => {

    this.setState((prevState) => ({ keyExtractDownload: !prevState.keyExtractDownload,
      selectedCorporateForDownload: data,
      checkFlag:checkFlag
    }));
   }
  handleSearchChange = (event) => {
    if (event.key === ENTER) {
      event.preventDefault()
      const requestBody = {
        corporateName: event.target.value
      }
      const pageDescription = {
            pageNo: 0,
            pageSize: this.state.pageSize || 10
          };
      this.setState({
        inputText: event.target.value,
        pageNo: 0,
        loading: true
      });
      this.props.listCorporate({ requestBody, pageDescription });
    }
  }

  toggleScoreExtractDownloadModal = (data) =>{

    this.setState((prevState) => ({
      scoreExtractDownload: !prevState.scoreExtractDownload,
      selectedCorporateForDownload: data ? data : prevState.selectedCorporateForDownload,
      fromDate: null,
      toDate: null,
    }));

  }

  toggleCLMExtractDownloadModal = (data) =>{

    this.setState((prevState) => ({
      clmExtractDownload: !prevState.clmExtractDownload,
      selectedCorporateForDownload: data ? data : prevState.selectedCorporateForDownload,
      fromDate: null,
      toDate: null,
    }));

  }

  toggleKeyExtractDownloadModal = () =>{
    this.setState((prevState) => ({
      keyExtractDownload: !prevState.keyExtractDownload,
      extractionFromDate: null,
      extractionToDate: null,
      checkFlag:""
    }));

  }
 handleTableChange = (newPageNo, newPageSize) => {
   this.fetchCorporateList(newPageNo, newPageSize);
 };

  handleDateChange = (date, type) => {
    switch (type) {
        case FROM_DATE:
            this.setState({
                fromDate: date
            })
            break;
        case TO_DATE:
            this.setState({
                toDate: date
            })
            break;
        default:
    }
  }


  handleToDateChange = (date) => {
    this.setState({
      extractionToDate:date
    })
    console.log(this.state.extractionToDate)


  }
  handleFromDateChange = (date) => {
    this.setState({
      extractionFromDate:date
    })
    console.log(this.state.extractionFromDate)
}

  downloadScoreBreakUp = () => {
    this.props.preloading(true);
    this.props.downloadScoreBreakupExcelFile({
        corporateId: this.state.selectedCorporateForDownload.id,
        fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
        toDate: moment(this.state.toDate).format("DD-MM-YYYY")
    })
    this.toggleScoreExtractDownloadModal();
  }

  downloadCLMBreakUp = () => {
    this.props.preloading(true);
    this.props.downloadCLMBreakupExcelFile({
        corporateId: this.state.selectedCorporateForDownload.id,
        fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
        toDate: moment(this.state.toDate).format("DD-MM-YYYY")
    })
    this.toggleCLMExtractDownloadModal();
  }


  downloadKeyExtraction = () => {
    console.log(this.state.extractionFromDate)
    console.log(this.state.extractionToDate)
    this.props.preloading(true);
    const requestBody = {
      id: this.state.selectedCorporateForDownload.id,
      name: this.state.selectedCorporateForDownload.corporateName,
      extractionToDate: moment(this.state.extractionToDate).format("DD-MM-YYYY"),
      extractionFromDate: moment(this.state.extractionFromDate).format("DD-MM-YYYY")
  }
  if(this.state.checkFlag===checkFlagFinancial){
      this.props.downloadExcelFile(requestBody);
    }
    if(this.state.checkFlag===checkFlagNonFinancial){
      this.props.downloadNonFinancialExcelFile(requestBody);
    }
    if(this.state.checkFlag===checkFlagObjectList){
      this.props.downloadObjectListExcelFile(requestBody);
    }
    this.toggleKeyExtractDownloadModal()

  }

  handleCorprateOnboard = () => {
    this.setState(prevState => ({
      showOnboardModal: !prevState.showOnboardModal,
  }))
  }

  render() {
    let fromYear=this.state.fromYear
    let toYear=this.state.toYear
    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">List of all Corporates</h4>
        </div>
        <Card>
          <CardBody>
            <Row className="search-corporate">
              <Col sm='4'>
                <label>Corporate Name</label>
              </Col>
              <Col sm='12'>
                <Form className="form-search">
                  <FormGroup className="mb-0 input-search">
                    <i className="icon-search position-absolute"></i>
                    <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search within Corporates" autoComplete="off" />
                  </FormGroup>
                </Form>
              </Col>
                <Col className="d-flex gap-2">
                  <Button color="outline-primary" onClick={this.handleCorprateOnboard}>
                    <i className="fa fa-building me-1"></i>
                    Onboard
                  </Button>
                  {/* Download CSV for corporate */}
                  <Button color="outline-success"
                    onClick={() =>this.props.downloadCorporateCSV({preloading: this.props.preloading})}>
                    <i className="fa fa-download me-1"></i>
                        Download CSV
                  </Button>
                </Col>                
            </Row>
            <Table
              data={Array.isArray(this.state.corporateList?.content)
                            ? this.state.corporateList.content
                            : []}
              columns={TABLE_COLUMN}
              manual={true}
              pages={this.props.corporateList?.totalPages || 1}
              page={this.state.pageNo}
              pageSize={this.state.pageSize}
              onPageChange={(pageNo) => this.handleTableChange(pageNo, this.state.pageSize)}
              onPageSizeChange={(pageSize, pageNo) => this.handleTableChange(pageNo, pageSize)}
              loading={this.state.loading}
              noDataText="No Corporates Available"
            />
          </CardBody>
        </Card>
        <Modal show={this.state.showModal} className='Large-Modal payment-data-modal upload-action-modal'>
          {this.state.body}
        </Modal>
        <Modal show={this.state.confirmModal} className='Modal confirm-modal' >
          {this.state.confirmModalBody}
        </Modal>
        {/* Score Break-Up Extraction modal */}
        <Modal show={this.state.scoreExtractDownload} className='Modal shadow-none crawler-status-modal' >
            <ModalHeader>Score Break-Up Report</ModalHeader>
            <ModalBody style={{ paddingBottom: "190px" }}>
              <Row>
                <Col>
                  From Date <DatePicker className="form-control" selected={this.state.fromDate} onChange={(date) => this.handleDateChange(date, FROM_DATE)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
                <Col >
                  To Date <DatePicker className="form-control" selected={this.state.toDate} onChange={(date) => this.handleDateChange(date, TO_DATE)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleScoreExtractDownloadModal}>Close</Button>
              <Button color="primary" disabled={!this.state.fromDate || !this.state.toDate} onClick={this.downloadScoreBreakUp}>Download Report</Button>
            </ModalFooter>
        </Modal>

        <Modal show={this.state.clmExtractDownload} className='Modal shadow-none crawler-status-modal' >
            <ModalHeader>CLM Break-Up Report</ModalHeader>
            <ModalBody style={{ paddingBottom: "190px" }}>
              <Row>
                <Col>
                  From Date <DatePicker className="form-control" selected={this.state.fromDate} onChange={(date) => this.handleDateChange(date, FROM_DATE)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
                <Col >
                  To Date <DatePicker className="form-control" selected={this.state.toDate} onChange={(date) => this.handleDateChange(date, TO_DATE)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleCLMExtractDownloadModal}>Close</Button>
              <Button color="primary" disabled={!this.state.fromDate || !this.state.toDate} onClick={this.downloadCLMBreakUp}>Download Report</Button>
            </ModalFooter>
        </Modal>

        <OneClickCorparateOnBoarding {...this.props} showOnboardModal = {this.state.showOnboardModal} closeModal = {this.handleCorprateOnboard}/>

        <Modal show={this.state.keyExtractDownload} className='Modal shadow-none crawler-status-modal' >
            <ModalHeader>Corporate Key Extraction </ModalHeader>
            <ModalBody style={{ paddingBottom: "190px" }}>
              <Row>
                <Col>
                  From Date <DatePicker className="form-control" selected={this.state.extractionFromDate} onChange={(date) => this.handleFromDateChange(date)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
                <Col >
                  To Date <DatePicker className="form-control" selected={this.state.extractionToDate} onChange={(date) => this.handleToDateChange(date)} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleKeyExtractDownloadModal}>Close</Button>
              <Button color="primary" disabled={!this.state.extractionFromDate || !this.state.extractionToDate} onClick={this.downloadKeyExtraction}>Download</Button>
            </ModalFooter>
        </Modal>

      </Col>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  corporateList: state.corporateListData.corporateList,
  corporateListFailure: state.corporateListData.corporateListError,
  checkTransactionData: state.corporateListData.transactionCheckExist,
  checkTransactionDataFailure: state.corporateListData.transactionCheckExistFailure,
  transactionDataUpload: state.corporateListData.transactionDataUpload,
  transactionDataUploadFailure: state.corporateListData.transactionDataUploadFailure,
  transactionDataListSuccess: state.corporateListData.transactionDataList,
  transactionDataListFailure: state.corporateListData.transactionDataListFailure,
  deleteSuccess: state.corporateListData.deleteTransaction,
  deleteFailure: state.corporateListData.deleteTransactionFailure,
  downloadFile: state.corporateListData.downloadFile,
  downloadFileFailure: state.corporateListData.downloadFileFailure,
  downloadTemplate: state.corporateListData.downloadTemplate,
  downloadTemplateFailure: state.corporateListData.downloadTemplateFailure,
  downloadExcelFileFailure:state.corporateListData.downloadExcelFileFailure,
  downloadExcelFileSuccess:state.corporateListData.downloadExcelFileSuccess,
  downloadNonFinancialExcelFileSuccess:state.corporateListData.downloadNonFinancialExcelFileSuccess,
  downloadNonFinancialExcelFileFailure:state.corporateListData.downloadNonFinancialExcelFileFailure,
  downloadObjectListExcelFileSuccess:state.corporateListData.downloadObjectListExcelFileSuccess,
  downloadObjectListExcelFileFailure:state.corporateListData.downloadObjectListExcelFileFailure,
  downloadScoreBreakupExcelFileSuccess:state.corporateListData.downloadScoreBreakupExcelFileSuccess,
  downloadScoreBreakupExcelFileFailure:state.corporateListData.downloadScoreBreakupExcelFileFailure,

  downloadCLMBreakupExcelFileSuccess:state.corporateListData.downloadCLMBreakupExcelFileSuccess,
  downloadCLMBreakupExcelFileFailure:state.corporateListData.downloadCLMBreakupExcelFileFailure,
})

const mapDispatchToProps = (dispatch) => ({
  listCorporate: (data) => { dispatch(listCorporate(data)) },
  transactionDataFileUpload: (data) => { dispatch(transactionDataFileUpload(data)) },
  transactionDataCheck: (data) => { dispatch(transactionDataCheck(data)) },
  transactionDataList: (data) => { dispatch(transactionDataList(data)) },
  deleteTransactionData: (data) => { dispatch(deleteTransactionData(data)) },
  downloadTransactionTemplate: (data) => { dispatch(downloadTransactionTemplate(data)) },
  downloadTransactionFile: (data) => { dispatch(downloadTransactionFile(data)) },
  downloadExcelFile: (data) => { dispatch(downloadExcelFile(data)) },
  downloadNonFinancialExcelFile: (data) => { dispatch(downloadNonFinancialExcelFile(data)) },
  downloadObjectListExcelFile:(data) =>{ dispatch(downloadObjectListExcelFile(data)) },
  downloadScoreBreakupExcelFile: (data) => {dispatch(downloadScoreBreakupExcelFile(data))},
  downloadCLMBreakupExcelFile: (data) => {dispatch(downloadCLMBreakupExcelFile(data))},
  downloadCorporateCSV: (payload) => {dispatch(downloadCorporateCSVRequest(payload))},
  preloading: (status) => { dispatch(Preloading(status)) }
 });


export default withAuth(connect(mapStateToProps, mapDispatchToProps)(ListCorporates))


